import { forwardRef } from '@chakra-ui/react';

import Button, { ButtonProps } from 'components/_core/Button';

export const CtaButton = forwardRef<ButtonProps, 'button'>((props, ref) => (
  <Button icon="arrow-right" ref={ref} {...props} />
));

export const SkipStepButton = forwardRef<ButtonProps, 'button'>(
  (props, ref) => (
    <Button marginRight="auto" ref={ref} variant="inline-primary" {...props} />
  ),
);
